<template>
	<div>
		<b-alert :show="!!error" variant="danger">{{error?.error||error}}</b-alert>
		<h4 class="mb-3">Overlays</h4>
		<b-spinner v-if="loading" />
		<div v-else-if="!overlays.length" class="overlay-empty-state text-center">
			<p class="text-muted mb-3">No overlays yet — create one to start composing a scene for OBS.</p>
			<b-button variant="primary" size="lg" :disabled="creating" @click="createOverlay">
				<b-spinner v-if="creating" small class="mr-1" /><b-icon v-else icon="plus-circle-fill" class="mr-1" />New overlay
			</b-button>
		</div>
		<template v-else>
			<div class="overlay-grid">
				<b-card v-for="o in overlays" :key="o.id" class="overlay-card">
					<h5 class="mb-1">{{o.name}}</h5>
					<p class="text-muted mb-3">{{o.width}}&times;{{o.height}}</p>
					<div class="d-flex" style="gap: .5rem">
						<b-button variant="primary" class="flex-fill" :to="`/overlays/${o.id}`">Open</b-button>
						<b-button variant="outline-danger" :disabled="deletingId === o.id" @click="deleteOverlay(o)">
							<b-spinner v-if="deletingId === o.id" small /><b-icon v-else icon="trash" />
						</b-button>
					</div>
				</b-card>
			</div>
			<div class="text-center mt-3">
				<b-button variant="primary" :disabled="creating" @click="createOverlay">
					<b-spinner v-if="creating" small class="mr-1" /><b-icon v-else icon="plus-circle-fill" class="mr-1" />New overlay
				</b-button>
			</div>
		</template>
	</div>
</template>

<script>
export default {
	data() { return {
		error: null,
		loading: false,
		creating: false,
		deletingId: null,
		overlays: [],
	}},
	async mounted() {
		this.loading = true;
		try {
			this.overlays = await this.$api.get('overlays');
		} catch(e) {
			this.error = e;
		} finally {
			this.loading = false;
		}
	},
	methods: {
		async createOverlay() {
			this.creating = true;
			try {
				const overlay = await this.$api.post('overlays', { name: 'Untitled overlay' });
				this.$router.push(`/overlays/${overlay.id}`);
			} catch(e) {
				this.error = e;
			} finally {
				this.creating = false;
			}
		},
		async deleteOverlay(overlay) {
			if(!confirm(`Delete "${overlay.name}"? This cannot be undone.`)) return;
			this.deletingId = overlay.id;
			try {
				await this.$api.delete(`overlays/${overlay.id}`);
				this.overlays = this.overlays.filter(o => o.id !== overlay.id);
			} catch(e) {
				this.error = e;
			} finally {
				this.deletingId = null;
			}
		},
	},
};
</script>

<style scoped>
.overlay-empty-state {
	padding: 4rem 1rem;
}

.overlay-grid {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
	gap: 1rem;
}
</style>
